import React from 'react';
import styles from '../Home.module.css';

/* ─── Floating Particle (CSS-only — the darkroom's dust motes) ─── */
const FloatingParticle: React.FC<{
  delay: number;
  size: number;
  x: string;
  y: string;
  duration: number;
}> = ({ delay, size, x, y, duration }) => (
  <div
    className={styles.floatingParticle}
    aria-hidden="true"
    style={{
      width: size,
      height: size,
      left: x,
      top: y,
      animationDuration: `${duration}s`,
      animationDelay: `${delay}s`,
    }}
  />
);

export default FloatingParticle;
